import React from 'react';
import BRAND from '../brand';
import { useCatalogLabels, genitivePlural, genitiveSingularLower } from '../catalogLabels';

function OrderSummary({ stemsSubtotal = 0, stemsServiceFee = 0, bouquetsSubtotalFinal = 0, bouquetsSubtotalBase = 0, bouquetServiceFee = 0, bouquetCount = 0, deliveryPrice = 0, bonusDiscount = 0, totalWithDelivery, bonusesEarned, postcardPrice = 0 }) {
  const catalogLabels = useCatalogLabels();
  // Названия разделов настраиваются владельцем («Букеты» → «Сеты»), склоняем по словарю;
  // неизвестное слово → форма без склонения: «Сумма заказа (Название):».
  const stemsSumLabel = genitivePlural(catalogLabels.products)
    ? `Сумма заказа ${genitivePlural(catalogLabels.products).toLowerCase()}:`
    : `Сумма заказа (${catalogLabels.products}):`;
  const bouquetGen = bouquetCount > 1
    ? (genitivePlural(catalogLabels.bouquets) || '').toLowerCase()
    : genitiveSingularLower(catalogLabels.bouquets);
  const bouquetSumLabel = bouquetGen
    ? `Сумма заказа ${bouquetGen}:`
    : `Сумма заказа (${catalogLabels.bouquets}):`;
  // Винительный падеж мн. числа для неодушевлённых = именительный («за стебли», «за сеты»)
  const stemsFeeLabel = `Сервисный сбор за ${catalogLabels.products.toLowerCase()}:`;
  const bouquetFeeLabel = `Сервисный сбор за ${catalogLabels.bouquets.toLowerCase()}:`;
  return (
    <>
      <div className="checkout-summary">
        {stemsSubtotal > 0 && (
          <>
            <div className="checkout-summary-row">
              <span>{stemsSumLabel}</span>
              <span>{stemsSubtotal.toLocaleString('ru-RU')} ₽</span>
            </div>
            <div className="checkout-summary-row">
              <span>{stemsFeeLabel}</span>
              <span>{stemsServiceFee.toLocaleString('ru-RU')} ₽</span>
            </div>
          </>
        )}
        {(bouquetsSubtotalBase > 0 || bouquetsSubtotalFinal > 0) && (
          <>
            <div className="checkout-summary-row">
              <span>{bouquetSumLabel}</span>
              <span>{(bouquetsSubtotalBase || bouquetsSubtotalFinal).toLocaleString('ru-RU')} ₽</span>
            </div>
            {bouquetServiceFee > 0 && (
              <div className="checkout-summary-row">
                <span>{bouquetFeeLabel}</span>
                <span>{bouquetServiceFee.toLocaleString('ru-RU')} ₽</span>
              </div>
            )}
          </>
        )}
        {postcardPrice > 0 && (
          <div className="checkout-summary-row">
            <span>Открытка:</span>
            <span>{postcardPrice.toLocaleString('ru-RU')} ₽</span>
          </div>
        )}
        {deliveryPrice > 0 && (
          <div className="checkout-summary-row">
            <span>Доставка:</span>
            <span>{deliveryPrice.toLocaleString('ru-RU')} ₽</span>
          </div>
        )}
        {bonusDiscount > 0 && (
          <div className="checkout-summary-row">
            <span>Со счёта {BRAND.name}:</span>
            <span style={{ color: '#4CAF50' }}>−{bonusDiscount.toLocaleString('ru-RU')} ₽</span>
          </div>
        )}
      </div>

      <div className="checkout-total">
        <span>Итого к оплате:</span>
        <span className="checkout-total-value">{totalWithDelivery.toLocaleString('ru-RU')} ₽</span>
      </div>

      {bonusesEarned > 0 && (
        <div className="checkout-bonus-earn">
          Получите <strong>+{bonusesEarned} ₽</strong> на счёт {BRAND.name}
        </div>
      )}
    </>
  );
}

export default OrderSummary;
